var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 13.92C31 20.359 26 21.359 26 27.36C26 30.458 22.877 30.719 20.5 30.719C18.447 30.719 13.914 29.94 13.914 27.358C13.914 21.36 9 20.36 9 13.92C9 7.889 14.285 3 20.083 3C25.883 3 31 7.889 31 13.92Z",
    fill: "#FFD983"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.167 35.36C24.167 36.188 21.933 37.86 20 37.86C18.067 37.86 15.833 36.188 15.833 35.36C15.833 34.532 18.066 34.86 20 34.86C21.933 34.86 24.167 34.532 24.167 35.36Z",
    fill: "#CCD6DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.707 13.153C24.316 12.762 23.684 12.762 23.293 13.153L20 16.446L16.707 13.153C16.316 12.762 15.684 12.762 15.293 13.153C14.902 13.544 14.902 14.176 15.293 14.567L19 18.274V28.86C19 29.413 19.448 29.86 20 29.86C20.552 29.86 21 29.413 21 28.86V18.274L24.707 14.567C25.098 14.176 25.098 13.544 24.707 13.153Z",
    fill: "#FFCC4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 33.86C26 34.964 25.104 35.86 24 35.86H16C14.896 35.86 14 34.964 14 33.86V27.86H26V33.86Z",
    fill: "#99AAB5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.999 34.86C13.519 34.86 13.095 34.513 13.014 34.024C12.923 33.48 13.291 32.964 13.836 32.874L25.836 30.874C26.38 30.776 26.896 31.151 26.986 31.696C27.077 32.24 26.709 32.756 26.164 32.846L14.164 34.846C14.109 34.856 14.053 34.86 13.999 34.86ZM13.999 30.86C13.519 30.86 13.095 30.513 13.014 30.024C12.923 29.48 13.291 28.964 13.836 28.874L25.836 26.874C26.38 26.777 26.896 27.151 26.986 27.696C27.077 28.24 26.709 28.756 26.164 28.846L14.164 30.846C14.109 30.856 14.053 30.86 13.999 30.86Z",
    fill: "#CCD6DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.58033c44d1aaaa6319d40469ed90cfe5.svg";
export { ForwardRef as ReactComponent };